import React from 'react'
import AgencyOfficialsBreadCrumb from './AgencyOfficialsBreadCrumb';
import AgencyOfficials from './AgencyOfficials';
function AgencyOfficialsPage() {
    return ( 
        <div className= "container-fluid">
            <AgencyOfficialsBreadCrumb />
            <AgencyOfficials />
        </div>
     );
}

export default AgencyOfficialsPage;